$.fn.watchIFrame = function (options) {
    var defaults = {
        obj: $(this),
        activeIframe: $('iframe')
    }
    var settings = $.extend(defaults, options);

    settings.obj.on("mouseenter mousemove", function () {
        $(settings.activeIframe).css({
            pointerEvents: 'all'
        });
        settings.obj.css({
            display: 'none'
        });

        setTimeout(function () {
            $(settings.activeIframe).css({
                pointerEvents: 'none'
            });
            settings.obj.css({
                display: 'block',
                // opacity: 0
            });
        }, 1000)
    });

};
$(".section__watchIFrame").watchIFrame(); 